import { render, staticRenderFns } from "./CreateAttachmentModal.vue?vue&type=template&id=514f97d2"
import script from "./CreateAttachmentModal.vue?vue&type=script&lang=js"
export * from "./CreateAttachmentModal.vue?vue&type=script&lang=js"
import style0 from "./CreateAttachmentModal.vue?vue&type=style&index=0&id=514f97d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports